import Bookmark2 from '@assets/icons/bookmark2.svg'
import { Icon } from './Icon'

export const Bookmark2Icon = Icon(Bookmark2)
